import axiosPlataformaClient from '../../../plugins/axios.plataforma.plugin';

export default {
  getQuizContent({ enrollmentId, topicId }) {
    return axiosPlataformaClient.custAxios().get(`/content/enrollment/${enrollmentId}/quiz/${topicId}`);
  },
  answerQuestion({ enrollmentId, topicId, questionId, optionId }) {
    return axiosPlataformaClient.custAxios().post(`/content/enrollment/${enrollmentId}/quiz/${topicId}`, {
      questionId,
      optionId
    });
  },
  finishAttempt({ enrollmentId, topicId, attemptId }) {
    return axiosPlataformaClient.custAxios().post(`/content/enrollment/${enrollmentId}/quiz/${topicId}/attempt/${attemptId}`);
  }
};
